import { on_ready, is_elementor_edit } from 'js/utils';
import { init_retina } from 'js/retina';
import { init_toggle_height } from 'js/toggle_height_init';

import { init_header } from 'modules/header/header';
import init_forms from 'modules/forms/forms';
import init_carousels from 'modules/carousel/carousel';
import { load_swiper_mobile } from 'modules/carousel/load_swiper_mobile';
import init_footer from 'modules/footer/footer';
import init_nav_menu from 'modules/menu/nav/nav';


// load global styles
import './main.scss';

document.addEventListener('swiper_mobile_ready',(e)=>{
    new e.Swiper_Mobile({
        container: '.swiper_mobile4',
        items: '.item_con',
        arrows: true,
    })
});

on_ready(()=>{

    init_footer();

    if( is_elementor_edit() ) return;
    
    // forms ui + gravityforms customizations
    // move outside of tasks queue, have issues with hooks registered late
    init_forms();

    init_header();

    init_nav_menu();

    init_carousels(); // swiper

    init_retina(); // @images

    init_toggle_height(); // toggle element height from 0 to default - for animating height

    load_swiper_mobile();

    on_mobile();
    
    init_dynamic_load();
    
    document.dispatchEvent(new Event('after_main_init'));
});

function on_mobile(){
    if( window.innerWidth > 768 ) return;
}

function init_dynamic_load(){

    // search popup: remove if not used
    // if( document.querySelector('.search_popup_open') ) {
    //     import('modules/search/search_popup/init');
    // }
    
    // burger / mobile menu: remove if not used
    if( document.querySelector('.slide_menu_open') ) {
        import('modules/menu/slide_menu/init');
    }

    // wishlist & compare: remove if not used
    // if( document.querySelector('.compare_count') ||
    //     document.querySelector('.wishlist_count') ) {
    //     import('modules/save_items/init');
    // }
    
    // cookie consent
    // if( !get_cookie('ff_cookie_consent') ) {
    //     import('modules/cookie_consent/simple/simple')
    // }
}

